export const grow =
  <Head extends () => any, Props, Return>(
    head: Head,
    body: (headState: ReturnType<Head>, props: Props) => Return
  ) =>
  (props: Props) =>
    body(head(), props)
